module.exports = __webpack_public_path__ + "static/media/summary-disabled.94241dd5.svg";